module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header'), _vm._v(" "), _c('div', {
    staticClass: "main-grid"
  }, [_c('div', {
    staticClass: "px-6 py-2 md:p-6 bg-gray-100"
  }, [_c('header', {
    staticClass: "mb-3"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.editingDescription = !_vm.editingDescription
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.list ? _vm.list.name : 'Ideas'))])]), _vm._v(" "), (_vm.list && !_vm.editingDescription) ? _c('p', {
    staticClass: "color-gray-light",
    on: {
      "click": function($event) {
        _vm.editingDescription = !_vm.editingDescription
      }
    }
  }, [_vm._v(_vm._s(_vm.list.description))]) : _vm._e(), _vm._v(" "), (_vm.editingDescription) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.list.description),
      expression: "list.description"
    }],
    ref: "description",
    staticClass: "input-description w-full text-sm mb-2",
    domProps: {
      "value": (_vm.list.description)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updateDescription.apply(null, arguments)
      },
      "blur": _vm.updateDescription,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.list, "description", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canClaimList) ? _c('div', {
    staticClass: "my-2"
  }, [(_vm.sentClaimEmail) ? _c('div', [_vm._m(0)]) : _c('div', [(!_vm.isClaiming) ? _c('button', {
    staticClass: "bg-blue-400 hover:bg-blue-800 text-white font-bold py-1 px-2 text-sm rounded",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isClaiming = true
      }
    }
  }, [_vm._v("\n                Claim this list\n              ")]) : _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendClaimEmail.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimEmail),
      expression: "claimEmail"
    }],
    staticClass: "p-2 block w-full border border-gray bg-white",
    attrs: {
      "required": "",
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.claimEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "block w-full bg-blue-400 hover:bg-blue-800 font-bold text-sm text-white p-2",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                    Claim via email\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "block text-center bg-gray-100 w-full p-2 text-xs text-gray my-2",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isClaiming = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.list.ideas.length) ? _c('div', [_c('button', {
    staticClass: "bg-green-400 hover:bg-green-800 text-white font-bold py-1 px-2 text-sm rounded",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleView.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              View " + _vm._s(_vm.view === 'list' ? 'on Map' : 'List') + "\n            ")])]) : _vm._e()]), _vm._v(" "), (_vm.view === 'list') ? _c('div', [_c('div', {
    staticClass: "idea-list"
  }, _vm._l((_vm.list.ideas), function(idea) {
    return _c('idea-card', {
      key: idea.id,
      attrs: {
        "data-id": idea.id,
        "idea": idea,
        "removable": true
      },
      on: {
        "remove": function($event) {
          return _vm.removeIdea(idea.id)
        }
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textToParse),
      expression: "textToParse"
    }],
    ref: "pasteInput",
    staticClass: "block w-full border border-gray bg-white p-2",
    staticStyle: {
      "min-height": "135px"
    },
    attrs: {
      "placeholder": "Paste in places..."
    },
    domProps: {
      "value": (_vm.textToParse)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textToParse = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('help-box', {
    attrs: {
      "list-page": ""
    }
  }), _vm._v(" "), (_vm.textToParse) ? _c('div', [_c('button', {
    staticClass: "p-2 text-xs text-white bg-indigo-700 mb-2",
    style: (_vm.listIsLoading ? 'opacity:0.7' : ''),
    attrs: {
      "disabled": _vm.listIsLoading
    },
    on: {
      "click": _vm.lookupPlaces
    }
  }, [_vm._v("\n                " + _vm._s(_vm.listIsLoading ? 'Looking up' : 'Lookup') + " these places" + _vm._s(_vm.listIsLoading ? '...' : '') + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "visible",
    attrs: {
      "id": "place-results"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.newIdeas) ? _c('div', _vm._l((_vm.newIdeas), function(newIdea, counter) {
    return _c('div', {
      key: newIdea.id,
      staticClass: "mb-1"
    }, [(counter >= _vm.loadedIdeas) ? _c('idea-card', {
      attrs: {
        "idea": newIdea
      }
    }) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('button', {
    staticClass: "block text-left bg-gray-100 w-full p-1 text-xs text-gray",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/create')
      }
    }
  }, [_vm._v("\n                ← Create a new list\n              ")])])], 1) : _c('div', [_c('map-view')], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-xs text-green"
  }, [_c('strong', [_vm._v("Sent!")]), _vm._v(" Check your email to claim this list.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a278a912"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ListPage.vue
// module id = 161
// module chunks = 1